// custom dependencies
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const deps = {
  gsap: gsap,
  ScrollTrigger: ScrollTrigger,
};

export default deps;
